import ConfirmBookingMutation from './ConfirmBookingMutation';

export default ConfirmBookingMutation;
